var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0005 17.3569C13.6161 17.3569 17.3576 13.6153 17.3576 8.99972C17.3576 4.3842 13.6161 0.642578 9.0005 0.642578C4.38498 0.642578 0.643356 4.3842 0.643356 8.99972C0.643356 13.6153 4.38498 17.3569 9.0005 17.3569Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0015 13.178C8.82398 13.178 8.68007 13.0341 8.68007 12.8566C8.68007 12.6791 8.82398 12.5352 9.0015 12.5352",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 13.178C9.1775 13.178 9.32141 13.0341 9.32141 12.8566C9.32141 12.6791 9.1775 12.5352 8.99998 12.5352",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75005 7.07031C6.75005 5.82767 7.7574 4.82031 9.00005 4.82031C10.2427 4.82031 11.25 5.82767 11.25 7.07031C11.25 8.31296 10.2427 9.32031 9.00005 9.32031V10.606",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer-support.aa659c86d397a78e334d15552e78dc7f.svg";
export { ForwardRef as ReactComponent };